<script setup>
import PortalEmptyState from 'dashboard/components-next/HelpCenter/EmptyState/Portal/PortalEmptyState.vue';
</script>

<template>
  <div class="w-full h-full bg-n-background">
    <PortalEmptyState />
  </div>
</template>
